import styled, { css } from 'styled-components';

import CommonGoogleAdsBanner from '~components/GoogleAdsBanner';

interface Props {
  isSticky?: boolean;
  fixedStickyTop?: number;
}

const cssSticky = css`
  ${({ theme }) => theme.media.pc} {
    position: fixed;
    top: 135px;
    right: 50%;
    margin-right: -568px;
  }
`;

const cssStickyFixed = css<Props>`
  ${({ theme }) => theme.media.pc} {
    position: absolute;
    top: ${({ fixedStickyTop }) => fixedStickyTop}px;
    right: 0;
    margin-right: 0;
  }
`;

export const Wrapper = styled.aside`
  margin-bottom: 16px;

  ${({ theme }) => theme.media.tablet} {
    margin-bottom: 32px;
  }

  ${({ theme }) => theme.media.pc} {
    position: absolute;
    right: 0;
    top: 0;
    margin-bottom: 0;
  }
`;

export const Contents = styled.div<Props>`
  width: 100%;

  ${({ theme }) => theme.media.pc} {
    position: absolute;
    right: 0;
    margin-right: 0;
    width: 300px;
  }

  ${({ isSticky }) => isSticky && cssSticky};
  ${({ fixedStickyTop }) => fixedStickyTop && cssStickyFixed}
`;

export const GoogleAdsBanner = styled(CommonGoogleAdsBanner)`
  ${({ theme }) => theme.media.with('mobile', 'tablet')} {
    margin: 0 auto;
    text-align: center;
  }
`;
